import { render, staticRenderFns } from "./lymsg.vue?vue&type=template&id=21392e5e&scoped=true&"
import script from "./lymsg.vue?vue&type=script&lang=js&"
export * from "./lymsg.vue?vue&type=script&lang=js&"
import style0 from "./lymsg.vue?vue&type=style&index=0&id=21392e5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21392e5e",
  null
  
)

export default component.exports